import PlanejamentoContratoFormApuracao from '../../../../produto/spa/planejamento-contrato/form/passo-apuracao/PlanejamentoContratoFormApuracao';

export default PlanejamentoContratoFormApuracao;
